<div class="not-applicable-card">
  <div class="card-content">
    <gc-text [variant]="'informationBold'" [textColor]="'critical'">{{
      'buildingPageModal.sectionNotApplicable.commentTitle' | translate
    }}</gc-text>
    <gc-text [variant]="'information'">{{ comment() }}</gc-text>
    <div class="card-actions">
      <gc-button
        [variant]="'secondary'"
        [size]="'small'"
        [icon]="'penToSquare'"
        [iconPosition]="'left'"
        [isLoading]="isLoading()"
        (clicked)="reactivate.emit()"
      >
        {{ 'buildingPageModal.sectionNotApplicable.reactivate' | translate }}
      </gc-button>
    </div>
  </div>
  @if (updatedBy() || updatedAt()) {
    <div class="card-meta">
      @if (updatedBy()) {
        <gc-text [variant]="'information'" [textColor]="'secondary'">
          {{ 'buildingPageModal.sectionNotApplicable.by' | translate }}
          {{ updatedBy() }}
        </gc-text>
      }
      @if (updatedAt()) {
        <gc-text [variant]="'information'" [textColor]="'secondary'">{{
          updatedAt() | date: 'yyyy-MM-dd'
        }}</gc-text>
      }
    </div>
  }
</div>
